import React from "react";
import { Row, Col } from "react-bootstrap";
import { AdminDashboardUser } from "@preveil-api";
import { DashboardUsage } from "src/common";
import _ from "lodash";

type AllProps = {
  users_list: AdminDashboardUser[];
}

// Description: Render the user table for the print modal
function PrintUserTableComponent(props: AllProps) {
  const { users_list } = props;

  const total_private_usage = _.sumBy(users_list, "private_usage");
  const total_shared_storage = _.sumBy(users_list, "shared_storage");
  const total_file_count = _.sumBy(users_list, "file_count");

  if (!users_list || users_list.length === 0) {
    return (
      <div className="print-user-table">
        <h3>User Storage</h3>
        <p>No users found.</p>
      </div>
    );
  }

  return (
    <div className="print-user-table">
      <h3>User Storage Details</h3>
      <div className="print-list-view">
        <Row className="header-row">
          <Col md="3">Name</Col>
          <Col md="3">Individual Usage</Col>
          <Col md="3">Shared Storage</Col>
          <Col md="2">File Count</Col>
        </Row>
        <div className="list-body">
          {users_list.map((user: AdminDashboardUser, index: number) => (
            <Row key={`print-user-${index}`}>
              <Col md="3">{user.display_name || ""}</Col>
              <Col md="3">{DashboardUsage.convertUsageToFriendlySizeList(user.private_usage)}</Col>
              <Col md="3">{DashboardUsage.convertUsageToFriendlySizeList(user.shared_storage)}</Col>
              <Col md="2">{user.file_count?.toString() || "0"}</Col>
            </Row>
          ))}
        </div>
        <Row className="footer-row">
          <Col md="3"><strong>Totals</strong></Col>
          <Col md="3"><strong>{DashboardUsage.convertUsageToFriendlySizeList(total_private_usage)}</strong></Col>
          <Col md="3"><strong>{DashboardUsage.convertUsageToFriendlySizeList(total_shared_storage)}</strong></Col>
          <Col md="2"><strong>{total_file_count}</strong></Col>
        </Row>
      </div>
    </div>
  );
}

export default React.memo(PrintUserTableComponent);
